import React from "react";
const ProjectDetailsModal = () => <section>hey i'm ProjectDetailsModal</section>;
export default ProjectDetailsModal;
